import "../scss/style.scss";
import { reviewSlider } from "./modules/reviewSlider.js";
import { partnersSlider } from "./modules/partnersSlider.js";
//import { headerActivities } from "./modules/headerActivities.js";
//import { headerRehabilitation } from "./modules/headerRehabilitation.js";
import { headerLanguage } from "./modules/headerLanguage.js";
import { burgerButton } from "./modules/burgerButton.js";
import { filtersSort } from "./modules/filtersSort.js";
import { teamLang } from "./modules/teamLang.js";



document.addEventListener("DOMContentLoaded", () => {
  reviewSlider();
  partnersSlider();
  headerLanguage();
  //headerActivities();
  //headerRehabilitation();
  burgerButton();
  filtersSort();
  teamLang();
});
